var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-footer" }, [
    _c("div", [_vm._v("全概率公式：")]),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.content))]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.calc_PB } }, [_vm._v("=")]),
    _vm._v(" "),
    _c("input", {
      class: [_vm.move_left ? "text_set_right" : "text_move_left"],
      staticStyle: { "background-color": "inherit" },
      attrs: { type: "text", onfocus: "this.select()", readonly: "true" },
      domProps: { value: _vm.value }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "btn_calc_a",
        style: { width: _vm.ele_num * 15 + 20 + "%", "max-width": "500px" },
        attrs: { title: "全概率计算" },
        on: { click: _vm.calc_PB }
      },
      [_vm._v("\n            全概率计算\n    ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }